import { render } from "./InitialState.vue?vue&type=template&id=252825dd"
import script from "./InitialState.vue?vue&type=script&lang=js"
export * from "./InitialState.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__